export default {
      id: "arrow_long_left-usage",
      viewBox: "0 0 62.5 11.5",
      url: __webpack_public_path__ + "sprite.svg#arrow_long_left",
      toString: function () {
        return this.url;
      }
    }